export default "__VITE_ASSET__B4aF5cUF__"